import dayjs from 'dayjs';
import { UserDTO } from '@/shared/user/user.dto';

export function hasActiveZangiaPlus(user?: UserDTO | null): boolean {
  if (!user) {
    return false;
  }
  return !!user.hasZangiaPlus && user.hasZangiaPlus > dayjs().unix();
}
